import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Switch } from 'react-router-dom';

const Relatorios = asyncComponent(() => import('../relatorios'));
const Ocorrencias = asyncComponent(() =>
  import('../cobranca/ocorrencias/ListaOcorrencias')
);
const RelOcorrenciasPdf = asyncComponent(() =>
  import('../relatorios/02Ocorrencias/02.02OcorrenciasPdf')
);
const RelProdutividade = asyncComponent(() =>
  import('../relatorios/06Negociador/06.01Produtividade')
);
const RelPausas = asyncComponent(() =>
  import('../relatorios/06Negociador/06.02Pausas')
);
const RelComissoesNeg = asyncComponent(() =>
  import('../relatorios/06Negociador/06.03Comissoes')
);
const rel0701 = asyncComponent(() =>
  import('../relatorios/07ConsultorComercial/07.01TitulosCaptadosMensal')
);
const rel0703 = asyncComponent(() =>
  import('../relatorios/07ConsultorComercial/07.03TitulosCaptadosFaixaVencto')
);
const rel0704 = asyncComponent(() =>
  import('../relatorios/07ConsultorComercial/07.04CredoresNEnviamBorderosXDias')
);
const rel0705 = asyncComponent(() =>
  import('../relatorios/07ConsultorComercial/07.05ComissaoCom')
);
const GeradorDeDocumentos = asyncComponent(() =>
  import('../relatorios/gerador-documentos')
);
const ConsultaGeral = asyncComponent(() =>
  import('../relatorios/01Processos/01.01ConsultaGeral')
);
const listaDeProcessos = asyncComponent(() =>
  import('../relatorios/01Processos/01.02ListaDeProcessos')
);
const StatusProcxCredor = asyncComponent(() =>
  import('../relatorios/01Processos/01.04StatusProcXCredor')
);
const ProcessosXNegociador = asyncComponent(() =>
  import('../relatorios/01Processos/01.05ProcessoXNegociador')
);
const ProcessosXRegiao = asyncComponent(() =>
  import('../relatorios/01Processos/01.06ProcessosXRegiao')
);
const listaDeTitulos = asyncComponent(() =>
  import('../relatorios/03Titulos/03.01ListadeDeTitulos')
);
const listaDeImportacoes = asyncComponent(() =>
  import('../relatorios/03Titulos/03.02ListaDeImportacoes')
);
const borderosEntrada = asyncComponent(() =>
  import('../relatorios/03Titulos/03.04BorderosEntrada')
);
const listaDeCredores = asyncComponent(() =>
  import('../relatorios/04Credores/04.01ListaDeCredores')
);
const RelatorioGerencialCredor = asyncComponent(() =>
  import('../relatorios/04Credores/04.02GerencialCredores')
);
const listaDeDevedores = asyncComponent(() =>
  import('../relatorios/05Devedores')
);
const listaRelContasReceber = asyncComponent(() =>
  import('../relatorios/08Financeiro/08.01ContasAReceber')
);
const listaRelContasPagar = asyncComponent(() =>
  import('../relatorios/08Financeiro/08.02ContasAPagar')
);
const listaRelMovContas = asyncComponent(() =>
  import('../relatorios/08Financeiro/08.03MovContas')
);
const listaRemuneracaoPorCredor = asyncComponent(() =>
  import('../relatorios/09Gerencial/09.02RemuneracaoCredor')
);
const listaRemuneracaoPorNegociador = asyncComponent(() =>
  import('../relatorios/09Gerencial/09.03RemunuracaoNegociador')
);
const RemessaRetornoEntradaConfirmada = asyncComponent(() =>
  import('../relatorios/RemessaRetorno/EntradaConfirmada')
);
const RemessaRetornoLiquidacoes = asyncComponent(() =>
  import('../relatorios/RemessaRetorno/Liquidacoes')
);
const RemessaRetornoDevolucoes = asyncComponent(() =>
  import('../relatorios/RemessaRetorno/Devolucoes')
);
const RemessaRetornoOcorrenciasRel = asyncComponent(() =>
  import('../relatorios/RemessaRetorno/Ocorrencias')
);
const RelatoriosEspecificos = asyncComponent(() =>
  import('../relatorios/Especificos')
);
const TitulosDuplicados = asyncComponent(() =>
  import('../relatorios/03Titulos/TitulosDuplicados/ListaTitulosDuplicados')
);
const ProcessoSemTitulos = asyncComponent(() =>
  import(
    '../relatorios/01Processos/ProcessosSemTitulos/ListaProcessosSemTitulos'
  )
);

export default function RelatorioRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/rel/criacao-documentos`}
          component={GeradorDeDocumentos}
          codigo="rel_gerador"
        />

        {/* Ocorrencias - 2.01 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-de-ocorrencias/`}
          component={Ocorrencias}
          codigo="rel_02"
        />
        {/* Ocorrencias - 2.02 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-de-ocorrencias-pdf/`}
          component={RelOcorrenciasPdf}
          codigo="rel_02"
        />
        {/* Ocorrencias - 2.02
        <PrivateRoute
          path={`${match.url}/rel/acordos-programados/`}
          component={Acordo}
          codigo="rel_02"
        /> */}

        {/* Processos - 1.01 */}
        <PrivateRoute
          path={`${match.url}/rel/consulta-geral`}
          component={ConsultaGeral}
          codigo="rel_01"
        />
        {/* Processos - 1.02 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-de-processos`}
          component={listaDeProcessos}
          codigo="rel_01"
        />
        {/* Processos - 1.04 */}
        <PrivateRoute
          path={`${match.url}/rel/processos-x-credor`}
          component={StatusProcxCredor}
          codigo="rel_01"
        />
        {/* Processos - 1.05 */}
        <PrivateRoute
          path={`${match.url}/rel/processos-x-negociador`}
          component={ProcessosXNegociador}
          codigo="rel_01"
        />
        {/* Processos - 1.06 */}
        <PrivateRoute
          path={`${match.url}/rel/processos-x-regiao`}
          component={ProcessosXRegiao}
          codigo="rel_01"
        />
        {/* Processos - 1.07 */}
        <PrivateRoute
          path={`${match.url}/rel/processos-sem-titulos`}
          component={ProcessoSemTitulos}
          codigo="rel_01"
        />

        {/* Titulos - 3.01 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-de-titulos`}
          component={listaDeTitulos}
          codigo="rel_03"
        />
        {/* Titulos - 3.02 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-de-importacoes`}
          component={listaDeImportacoes}
          codigo="rel_03"
        />
        {/* Titulos - 3.03 */}
        <PrivateRoute
          path={`${match.url}/rel/titulos-duplicados`}
          component={TitulosDuplicados}
          codigo="rel_03"
        />
        {/* Titulos - 3.04 */}
        <PrivateRoute
          path={`${match.url}/rel/borderos-entrada`}
          component={borderosEntrada}
          codigo="rel_03"
        />

        {/* Credores - 4.01 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-de-credores`}
          component={listaDeCredores}
          codigo="rel_04"
        />
        {/* Credores - 4.02 */}
        <PrivateRoute
          path={`${match.url}/rel/gerencial-por-credor`}
          component={RelatorioGerencialCredor}
          codigo="rel_04"
        />

        {/* Consultor/Comercial - 7.01 */}
        <PrivateRoute
          path={`${match.url}/rel/titulos-captados-mensal`}
          component={rel0701}
          codigo="rel_07"
        />
        {/* Consultor/Comercial - 7.03 */}
        <PrivateRoute
          path={`${match.url}/rel/titulos-captados-faixa`}
          component={rel0703}
          codigo="rel_07"
        />
        {/* Consultor/Comercial - 7.04 */}
        <PrivateRoute
          path={`${match.url}/rel/credores-nao-enviam-borderos-x-dias`}
          component={rel0704}
          codigo="rel_07"
        />

        {/* Consultor/Comercial - 7.05 */}
        <PrivateRoute
          path={`${match.url}/rel/comissoes-comercial`}
          component={rel0705}
          codigo="rel_07"
        />

        {/* Financeiro - 8.01 */}
        <PrivateRoute
          path={`${match.url}/rel/contas-a-receber`}
          component={listaRelContasReceber}
          codigo="rel_08"
        />
        <PrivateRoute
          path={`${match.url}/rel/contas-a-pagar`}
          component={listaRelContasPagar}
          codigo="rel_08"
        />
        <PrivateRoute
          path={`${match.url}/rel/mov-contas`}
          component={listaRelMovContas}
          codigo="rel_08"
        />

        <PrivateRoute
          path={`${match.url}/rel/lista-de-devedores`}
          component={listaDeDevedores}
          codigo="rel_05"
        />

        {/* Negociador - 06.01 */}
        <PrivateRoute
          path={`${match.url}/rel/produtividade`}
          component={RelProdutividade}
          codigo="rel_06"
        />
        {/* Negociador - 06.02 */}
        <PrivateRoute
          path={`${match.url}/rel/pausas`}
          component={RelPausas}
          codigo="rel_06"
        />

        {/* Negociador - 06.03 */}
        <PrivateRoute
          path={`${match.url}/rel/comissoes-negociador`}
          component={RelComissoesNeg}
          codigo="rel_06"
        />

        {/* Gerencial - 9.02 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-remuneracao-credor`}
          component={listaRemuneracaoPorCredor}
          codigo="rel_09"
        />
        {/* Gerencial - 9.03 */}
        <PrivateRoute
          path={`${match.url}/rel/lista-remuneracao-negociador`}
          component={listaRemuneracaoPorNegociador}
          codigo="rel_09"
        />
        {/** Remessa/Retorno */}
        <PrivateRoute
          path={`${match.url}/rel/entrada-confirmada`}
          component={RemessaRetornoEntradaConfirmada}
          codigo="rel"
        />
        <PrivateRoute
          path={`${match.url}/rel/liquidacoes`}
          component={RemessaRetornoLiquidacoes}
          codigo="rel"
        />
        <PrivateRoute
          path={`${match.url}/rel/devolucoes`}
          component={RemessaRetornoDevolucoes}
          codigo="rel"
        />
        <PrivateRoute
          path={`${match.url}/rel/ocorrencias`}
          component={RemessaRetornoOcorrenciasRel}
          codigo="rel"
        />
        <PrivateRoute
          path={`${match.url}/rel/personalizados`}
          component={RelatoriosEspecificos}
          codigo="rel"
        />

        <PrivateRoute
          path={`${match.url}/rel/inicio`}
          component={Relatorios}
          codigo="rel"
        />
        <PrivateRoute
          exact
          path={`${match.url}/rel`}
          component={Relatorios}
          codigo="rel"
        />
      </Switch>
    </>
  );
}
